import ProjectData from "@/data/ProjectData";

export default [
  new ProjectData(
    "project-1",
    "Flappy Bird (Phaser3)",
    "img/projects/flappy-bird.png",
    `https://birdman1104.github.io/flappy-bird/`,
    "#23bd69",
    true,
  ),
  new ProjectData(
    "project-8",
    "Playable Ad for Panic Singer (PixiJS)",
    "img/projects/panic-singer.png",
    `https://birdman1104.github.io/panic-singer-playable-v1/`,
    "#9c1c27",
  ),
  new ProjectData(
    "project-9",
    "Slot Game (PixiJS, Client-Server)",
    "img/projects/triple-slot.png",
    `https://birdman1104.github.io/slot-triple-win/`,
    "#033dfc",
  ),
  new ProjectData(
    "project-10",
    "EvoSolar Website (VueJS)",
    "img/projects/evosolar.png",
    `https://birdman1104.github.io/evosolar-website/`,
    "#c95e0c",
  ),
  new ProjectData(
    "project-12",
    "Pick Agency Website (VueJS)",
    "img/projects/pick-agency.png",
    `https://birdman1104.github.io/pick-agency/`,
    "#2d1b4e",
  ),
  new ProjectData(
    "project-11",
    "Rock-Paper-Scissors ultimate battle (PixiJS, MatterJS)",
    "img/projects/rock-paper-scissors.png",
    `https://birdman1104.github.io/rock-papers-scissors-battle/`,
    "#7b1fa6",
  ),
  new ProjectData(
    "project-2",
    "Playrix Playable Ad Test Task (PixiJS)",
    "img/projects/playrix.png",
    `https://birdman1104.github.io/playrix-test-task/`,
    "#F4511E",
  ),
  new ProjectData(
    "project-3",
    "Endless Sorting Game (PixiJS)",
    "img/projects/endless-sorting-game.png",
    `https://birdman1104.github.io/endless-sorting-game/`,
    "#F4511E",
  ),
  new ProjectData(
    "project-4",
    "HappyGames Test Task (PixiJS, Client-Server)",
    "img/projects/happyGames.png",
    `https://birdman1104.github.io/happygames-test-task/`,
    "#039BE5",
  ),
  new ProjectData(
    "project-5",
    "Horses Ride Game Animation (PixiJS, Client-Server)",
    "img/projects/horses-ride.png",
    `https://birdman1104.github.io/horses-ride-animation/`,
    "#43A047",
  ),
  new ProjectData(
    "project-6",
    "Crash Game Animation (PixiJS)",
    "img/projects/crash.png",
    `https://birdman1104.github.io/aviator-mechanics/`,
    "#FFB300",
  ),
  new ProjectData(
    "project-7",
    "Klebo Games Test Task (Phaser3)",
    "img/projects/klebo-games.png",
    `https://birdman1104.github.io/klebo-games-test-task/`,
    "#FFB300",
  ),
];
